module.exports = __webpack_public_path__ + "img/poc.5cebff26.jpg";